import React from 'react';
import { Store } from 'pullstate';
import { usePause } from '../utils';
import { PuzzleStoreBase } from '../../../../utils/types';
import './PauseCover.less';

type PauseCoverProps = {
  store: Store<PuzzleStoreBase>;
  useCompleted?: boolean;
  completed?: boolean;
};

const PauseCover = ({ store, useCompleted, completed }: PauseCoverProps) => {
  const showPauseCover = usePause(store, useCompleted, completed);
  const unpause = () => {
    store.update(s => { s.isPaused = false; });
  };

  if (!showPauseCover) return null;

  return (
    <div className="pauseCover">
      <div className="pausedNotice">(Paused)</div>
      <div className="pausedPrompt">Ready to continue?</div>
      <button className="continueButton" onClick={unpause}>Resume</button>
    </div>
  );
};

export default PauseCover;